import { gql } from "@apollo/client";

import { STOCK_BASKET_FIELDS } from "./organisations/shared";

export const APPLY_DISCOUNT_TO_STOCK_MUTATION = gql`
  mutation ApplyDiscountToStockMutation($input: ApplyDiscountToStockMutationInput!) {
    applyDiscountToStockMutation(input: $input) {
      stockBasket {
        ...StockBasketFields
      }
      errors {
        field
        messages
      }
    }
  }
  ${STOCK_BASKET_FIELDS}
`;

export const REMOVE_DISCOUNT_FROM_STOCK_MUTATION = gql`
  mutation RemoveDiscountFromStockMutation($input: RemoveDiscountFromStockMutationInput!) {
    removeDiscountFromStockMutation(input: $input) {
      stockBasket {
        ...StockBasketFields
      }
      errors {
        field
        messages
      }
    }
  }
  ${STOCK_BASKET_FIELDS}
`;
